/* Copyright 2023 (Unpublished) Verto Inc. */

export const environment = {
  production: true,
  settings: {
    backendUrl: '',
  },
  oauth: undefined,
};
